export default __webpack_public_path__ + "static/media/8.f51de9b7.png";